import { render, staticRenderFns } from "./CreatePromocodePage.vue?vue&type=template&id=1bcc6156&scoped=true&"
import script from "./CreatePromocodePage.vue?vue&type=script&lang=js&"
export * from "./CreatePromocodePage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePromocodePage.vue?vue&type=style&index=0&id=1bcc6156&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc6156",
  null
  
)

export default component.exports